export default __webpack_public_path__ + "static/media/kara-eads-AemWnTSPxoE-unsplash.6b66f7d4.jpg";